import { render, staticRenderFns } from "./deviceManagement.vue?vue&type=template&id=2f1b439f"
import script from "./deviceManagement.vue?vue&type=script&lang=js"
export * from "./deviceManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports